import React from "react";
import styles from "./TextArea.module.css";

const Textarea = React.forwardRef(({ label, error, required, ...props }, ref) => {
  return (
    <div className={styles.textareaGroup}>
      {label && (
        <label className={styles.label}>
          {label}
          {required && <span className={styles.requiredDot}> *</span>}
        </label>
      )}

      <textarea ref={ref} className={styles.textarea} {...props} />

      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
});

export default Textarea;
